<template>
  <div>

    <Breadcrumbs
        :title="project && project.id ? project.translation['en'].name + ' / ' + $t('message.menu_modules') : '&nbsp;'"/>

    <ConfirmModal id="step-requests-modal" ref="requests-modal" :okButtonText="$t('message.request')"
                  @ok-handle="requestConfirm"></ConfirmModal>
    <ConfirmModal id="step-revert-modal" ref="revert-modal" :okButtonText="$t('message.revert')"
                  @ok-handle="requestRevert"></ConfirmModal>
    <ConfirmModal id="step-approve-modal" ref="approve-modal" :okButtonText="$t('message.approve')"
                  @ok-handle="requestApprove"></ConfirmModal>

    <b-modal id="locked_step_modal" :title="$t('message.lock_step_modal_title')" class="theme-modal" hide-footer
             no-close-on-backdrop>
      <p style="text-align: center">
        {{ $t('message.lock_step_modal_description') }}
      </p>
    </b-modal>

    <b-modal id="dictionary_modal" class="theme-modal" hide-footer
             no-close-on-backdrop>
      <template #modal-title>
        {{ selectedTitle }}<br/>
        <div v-if="locale != 'en'" style="font-size: 12px;">{{ selectedSubtitle }}</div>
      </template>
      <div style="word-break: break-all;text-align: justify" v-html="selectedDescription"></div>
    </b-modal>

    <div class="container-fluid">

      <div class="alert alert-danger" style="overflow: auto;display: flex;align-items: center" role="alert"
           v-if="requestApproveShow && !canRequestApprove && project">
        {{ $t('message.no_supervizor') }}
        <router-link :to="{name: 'ProjectTeam', params: {id: $route.params.id}}" class="btn float-right btn-danger"
                     style="margin-left: auto">
          {{ $t('message.invite_supervizor') }}
        </router-link>
      </div>

      <div class="email-wrap">

        <PlanSummary
            v-if="isSummery && project && project.steps && project.steps.length && planSteps.length"
            :project="project"
            :planSteps="planSteps"
            :key="isSummery">
        </PlanSummary>

        <div class="row" v-if="!isSummery">
          <div class="col-xl-3 col-md-12">
            <div class="email-left-aside">
              <div class="card">
                <div class="card-body">
                  <div class="email-app-sidebar">
                    <ul class="nav main-menu" role="tablist">

                      <li class="nav-item" v-for="(step, index) in steps" :key="step.id">
                        <a class="" :class="{'step-selected' : step.id == stepSelected.id}"
                           @click="setSelected(step)">
                              <span class="title">

                                <SectionStatus :project="project" :step="step"></SectionStatus>

                                  {{ $route.params.module }}.{{ index + 1 }}.
                                 {{
                                  step.original.translation[locale] ? step.original.translation[locale].name : step.original.translation['en'].name
                                }}
                              </span>
                          <i v-if="step.original_id == 0" class="icon-trash pull-right"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-9 col-md-12" v-if="stepSelected != null">

            <div class=" default-according">

              <div>
                <b-card no-body class="mb-2 no-padding">
                  <b-card-header header-tag="div" class="bg-primary">
                    <h5 class="mb-0" style="color: white;position: relative">
                      <b-button
                          class="titleVisible ? null : 'collapsed'"
                          :aria-expanded="titleVisible ? 'true' : 'false'"
                          aria-controls="collapse-4"
                          @click="toggleSection"
                      >{{ returnTrans(stepSelected) }}
                      </b-button>
                    </h5>
                  </b-card-header>
                  <b-collapse
                      v-model="titleVisible"
                      :id="'primary_icon_1'" accordion="my-accordion-icon-primary"
                      role="tabpanel">
                    <b-card-body>
                      <b-card-text>
                        <div class="card-body">
                                                 <span @click="openDic"
                                                       class="card-body card-description"
                                                       v-html="processedHtml(stepSelected, 'description')">
                                                        </span>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>

              <ProjectRichTextArea :role="role" v-for="(step, index) in stepSelected.subSteps"
                                   :key="step.id"
                                   :section="step"
                                   :index="index + 1"
                                   :project="project"
                                   :steps="steps"
                                   :stepSelected="stepSelected"
                                   :canRequestApprove="canRequestApprove"
                                   @request-check="requestCheck"
                                   @approve-task="approveTask"
                                   @revert-task="revertTask"
                                   @open-dic="openDic"
                                   @setLockStep="setLockStep"
                                   @openLockModal="openLockModal"
              >
              </ProjectRichTextArea>
            </div>


            <div class="card"
                 v-if="stepSelected.original.translation[locale] ?  stepSelected.original.translation[locale].placeholder != '' : stepSelected.original.translation['en'].placeholder != ''">
              <VueReadMoreSmooth :lines="6" :g-lines="1">

                  <span @click="openDic"
                        class="card-body card-description"
                        v-html="processedHtml(stepSelected, 'placeholder')">
                              </span>
              </VueReadMoreSmooth>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import ProjectRichTextArea from "@/pages/Projects/ProjectPlan/ProjectRichTextArea";
import VueReadMoreSmooth from "vue-read-more-smooth";
import PlanSummary from "@/pages/Projects/ProjectPlan/PlanSummary";
import SectionStatus from "./ProjectList/SectionStatus";
import ConfirmModal from "../Shared/ConfirmModal";
// import PlanSingleDictionary from "@/pages/Projects/ProjectPlan/PlanSingleDictionary";

export default {
  components: {ConfirmModal, SectionStatus, PlanSummary, ProjectRichTextArea, VueReadMoreSmooth},
  data() {
    return {
      titleVisible: false,
      selectedDescription: null,
      selectedTitle: null,
      selectedSubtitle: null,
      steps: [],
      planSteps: [],
      project: {},
      stepSelected: null,
      dictionary: [
        {word: 'wonder', description: 'Some description'},
        {word: 'business', description: 'Additional description'}
      ],
      lastOpenStep: null,
      stepLockTimer: null,
      canRequestApprove: false,
      requestApproveShow: false
    };
  },
  async created() {

    this.$store.dispatch('shared/setLoading', true)

    this.project = await this.$store.dispatch('projects/getProject', this.$route.params.id)

    this.planSteps = await this.$store.dispatch('plan/loadSteps', {
      groupId: this.project.group_id,
      lang: this.$i18n.locale
    })

    this.project.steps.forEach((item) => {
      item.original = this.planSteps.find((record) => {
        return record.id == item.original_id
      })
    })

    let mainSteps = this.project.steps.filter((item) => {
      return item.original != undefined && item.original && item.original.parent_id == this.$route.params.module
    })

    mainSteps.sort((a, b) => a.original.order - b.original.order || a.original.id - b.original.id);

    mainSteps.forEach((category) => {

      let other = this.project.steps.filter((item) => {
        return item.original != undefined && item.original.parent_id == category.original.id
      })

      other.sort((a, b) => a.original.order - b.original.order || a.original.id - b.original.id);

      category.subSteps = other

    })

    this.$set(this, 'steps', mainSteps);

    if (mainSteps.length) {

      this.stepSelected = mainSteps[0]

      this.stepSelected.dictionary = false


      if (this.$route.query && this.$route.query.section) {

        let query = Object.assign({}, this.$route.query)

        this.stepSelected = mainSteps.find((item) => {
          return item.original.id == query.section
        })

      } else {
        this.stepSelected = mainSteps[0]
      }
    }

    // this.$eventBus.$on('update-single-step', this.updateSingleStep)

    this.$store.dispatch('shared/setLoading', false)


    if (this.$route.query && this.$route.query.section && this.$route.query.assignment) {

      let selectedSection = this.steps.find((item) => {
        return item.original.id == this.$route.query.section
      })

      if (selectedSection) {
        if (selectedSection.id != this.stepSelected.id) {
          this.setSelected(selectedSection)
        }
      }
    }

    let mentorExist = this.project.share.filter((item) => {
      return item.is_mentor == 1
    })

    this.canRequestApprove = mentorExist.length ? true : false
    this.requestApproveShow = true
  },

  methods: {

    toggleSection() {
      this.titleVisible = !this.titleVisible
    },

    returnTrans(stepSelected) {
      return stepSelected.original.translation[this.locale] ? stepSelected.original.translation[this.locale].name : stepSelected.original.translation['en'].name
    },
    openLockModal() {

      this.$bvModal.show('locked_step_modal')
    },

    setLockStep(step) {

      if (step.visible) {

        this.lastOpenStep = step.stepId

        if (!this.stepLockTimer) {

          this.stepLockTimer = setInterval(() => {

            this.$store.dispatch('projects/setLock', {
              stepId: this.lastOpenStep,
              is_locked: 1,
              loadingIcon: false
            })

          }, 1000 * 60 * 2);
        }

      } else {
        this.lastOpenStep = null
        clearInterval(this.stepLockTimer);
      }

    },

    openDic(e) {
      if (e.target.classList.contains('highlight')) {

        let description = this.$store.getters['plan/getDictionary'].find((item) => {
          return item.translation[this.locale] && item.translation[this.locale].name == e.target.getAttribute('tr')
        })

        if (description == undefined) {
          description = this.$store.getters['plan/getDictionary'].find((item) => {
            return item.translation['en'] && item.translation['en'].name == e.target.getAttribute('tr')
          })
        }

        if (description) {

          this.selectedDescription = description.translation[this.locale] ? description.translation[this.locale].description : description.translation['en'].description
          this.selectedTitle = description.translation[this.locale] ? description.translation[this.locale].name : description.translation['en'].name
          this.selectedSubtitle = description.translation['en'].name

          this.$bvModal.show('dictionary_modal')
        }
      }
    },

    highlighter(string, val) {

      String.prototype.splice = function (start, delCount, newSubStr) {
        return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
      };
      var spanBegin = "<span tr='" + val + "' class='highlight'>";
      var spanEnd = "</span>";
      var search_regexp = new RegExp(val, "gi");
      var myArray;
      var indexCollection = [];
      while ((myArray = search_regexp.exec(string)) !== null) {
        indexCollection.push(myArray.index);
      }

      indexCollection.forEach(function (stringIdx, idxInCol, col) {
        var offset1 = (idxInCol * (spanBegin.length + spanEnd.length));
        var offset2 = stringIdx + offset1 + val.length + spanBegin.length;
        string = string.splice((stringIdx + offset1), 0, spanBegin);
        string = string.splice(offset2, 0, spanEnd);
      });

      return string;
    },

    processedHtml(step, label) {

      let text = step.original.translation[this.locale] ? step.original.translation[this.locale][label] : step.original.translation['en'][label]

      let translatedText = text;
      let dictionary = this.$store.getters['plan/getDictionary']

      dictionary.forEach((item) => {

        if (item.translation[this.locale] && item.translation[this.locale].name && item.translation[this.locale].name != '') {
          translatedText = this.highlighter(translatedText, item.translation[this.locale].name)
        }
      })

      return translatedText
    },
    updateSingleStep(data) {

      let selected = this.project.steps.find((item) => {
        return item.id == data.id
      })

      selected.description = data.description
    },
    setSelected(step) {

      this.$store.dispatch('shared/setLoading', true)
      setTimeout(function () {
        this.$set(this, 'stepSelected', step)

        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});

      }.bind(this), 0)

      setTimeout(function () {
        this.$store.dispatch('shared/setLoading', false)
      }.bind(this), 2000)
    }
    ,

    async setTaskRequest(task, status) {
      await this.$store.dispatch('projects/updateTaskStatus', {
        task: task,
        status: status
      })

      let selectedFromProject = this.project.steps.find((item) => {
        return item.id == task.id
      })

      this.$set(selectedFromProject, 'is_active', status)

      this.updateSectionStatus(task, status)
      
    }
    ,
    updateSectionStatus(task, status) {

      this.steps.forEach((step) => {

        let selected = step.subSteps.find((item) => {
          return item.id == task.original_id
        })

        if (selected) {
          selected.is_active = status
        }

      })

      this.steps.forEach((item) => {

        // let allSubSteps = item.subSteps.length;

        // let allApproved = item.subSteps.filter((record) => {
        //   return record.is_active == 3;
        // })

        let allWaiting = item.subSteps.filter((record) => {
          return record.is_active == 2;
        })

        item.waitingApprove = allWaiting.length ? true : false
        // item.allApproved = allSubSteps == allApproved
      })

    }
    ,
    approveTask(task) {
      this.$refs['approve-modal'].openModal(task, this.$t('message.approve_step_modal_title'), this.$t('message.request_approve'), this.$t('message.are_you_sure'), task)
    },
    requestConfirm(record) {
      this.setTaskRequest(record, 2)
    },
    requestRevert(record) {
      this.setTaskRequest(record, 1)
    },
    requestApprove(record) {
      this.setTaskRequest(record, 3)
    },


    requestCheck(task) {
      this.$refs['requests-modal'].openModal(task, this.$t('message.approve_step_modal_title'), this.$t('message.request_approval'), this.$t('message.are_you_sure'), task)
    }
    , revertTask(task) {

      this.$refs['revert-modal'].openModal(task, this.$t('message.approve_step_modal_title'), this.$t('message.request_revert'), this.$t('message.are_you_sure'), task)
    }
  },
  computed: {
    locale: function () {
      return this.$i18n.locale
    }
    ,
    isSummery: function () {
      return this.$route.params.module == 'summary'
    }
    ,
    role: function () {

      let user = this.$store.getters['shared/getUser']

      if (!user) {
        return null
      }

      if (!this.project) {
        return null
      }

      let currentUserRoles = this.project.share.find((item) => {
        return item.user_id == user.id
      })

      return {
        content: currentUserRoles.is_editor ? 'editor' : currentUserRoles.is_mentor ? 'mentor' : 'reader',
        personal: this.project.user_id == user.id
      }
    }
  }
}
;
</script>

<style>

.card h5 {
  color: #7366ff;
}

.main-menu .nav-item {
  cursor: pointer;
}

.step-selected {
  background-color: rgba(115, 102, 255, 0.15);
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  color: #7366ff;
}

.card-description * {
  color: #2c323f !important;
}

.card-description p {
  margin-bottom: 10px !important;
  line-height: 180% !important;
}

.card-description ul li {
  margin-bottom: 10px !important;
  padding-left: 10px !important;
}

.tooltip-custom {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip-custom .tooltiptext {
  visibility: hidden;
  width: 400px;
  text-align: center;
  background-color: #f7f7f7;
  border-radius: 6px;
  color: black;
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -200px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-custom .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.tooltip-custom:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.highlight {
  color: green !important;
}

.email-wrap .email-app-sidebar ul li a {
  padding-right: 5px !important;
}

.email-wrap .email-app-sidebar .main-menu > li a {
  line-height: 180% !important;
}

.email-wrap .email-app-sidebar .main-menu > li {
  margin-bottom: 10px;
  border: 1px solid #F7F6FF;
  border-radius: 6px;
}

.card p {
  line-height: 180% !important;
}
</style>